export default __webpack_public_path__ + "static/media/logo.6515d0ff.svg";